import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { Tooltip } from "../tooltip";
import { useConfig } from "../_util/config-context";
import { forwardRefWithStatics } from "../_util/forward-ref-with-statics";
import { teaIconsMap } from "./tea-icons-map";
var colorClassArray = ["success", "warning", "pending", "error", "brand"];
var getColorClass = function (color) {
    return colorClassArray.includes(color);
};
export var Icon = forwardRefWithStatics(function Icon(props, ref) {
    var _a;
    var classPrefix = useConfig().classPrefix;
    var _b = props.type, type = _b === void 0 ? "" : _b, size = props.size, className = props.className, tooltip = props.tooltip, link = props.link, color = props.color, htmlProps = __rest(props, ["type", "size", "className", "tooltip", "link", "color"]);
    var label = type.replace("-blue", "").replace("-hover", "");
    // 查看 type 是否在 @tencent/tea-icons-react 中是否存在映射
    var IconComponent = teaIconsMap[type];
    var iconClassName = classNames(className, (_a = {},
        _a[classPrefix + "-icon"] = !IconComponent,
        _a[classPrefix + "-icon-" + type] = !IconComponent,
        _a[classPrefix + "-util-icon-" + color] = getColorClass(color),
        _a), {
        "size-s": size === "s",
        "size-l": size === "l",
    });
    var icon;
    // 没有映射，走老版本 icon
    if (!IconComponent) {
        var Parent = link ? "a" : "i";
        icon = (React.createElement(Parent, __assign({ ref: ref, className: iconClassName, role: "img", "aria-label": label }, htmlProps)));
    }
    else {
        var newProps = __assign({ ref: ref, className: iconClassName, role: "img", "aria-label": label }, htmlProps);
        // size 是数字
        if (typeof size === "number") {
            Object.assign(newProps, { size: size });
        }
        else if (size === "l") {
            Object.assign(newProps, { size: 32 });
        }
        if (color) {
            Object.assign(newProps, { color: color });
        }
        // 找到映射分支
        icon = link ? (React.createElement("a", __assign({ ref: ref, className: iconClassName, role: "img", "aria-label": label }, htmlProps), React.cloneElement(IconComponent, newProps))) : (React.cloneElement(IconComponent, newProps));
    }
    if (tooltip) {
        return React.createElement(Tooltip, { title: tooltip }, icon);
    }
    return icon;
}, {});
Icon.displayName = "Icon";
//# sourceMappingURL=Icon.js.map